import { Box, Typography } from "@mui/material";
import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemText from "@mui/material/ListItemText";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch, useSelector } from "react-redux";
import { deleteFile, downloadAttachment } from "./productGroupSetupSlice";
import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";

export default function Attachments() {
   const dispatch = useDispatch();
	const pgState = useSelector((store) => store.productGroupSetup);
	const { files } = pgState;

	function handleDeleteFile(file) {
		console.log(file);
		dispatch(deleteFile(file));
	}

   function handleDownloadFile(file) {
      console.log(file);
      dispatch(downloadAttachment({ fileName: file.name ? file.name : file.filePath }));
   }

	return (
		<Box sx={{ mt: 2 }}>
			{" "}
			<Box
				sx={{
					// bgcolor: "blue.light",
					height: "auto",
					pt: 1.4,
					pl: 1,
					boxShadow: "0 2px #efefef",
				}}
			>
				<Typography sx={{ fontWeight: "bold", mt: -8, mb: 2,}}>Attachments</Typography>{" "}
				<List dense={false}>
					{files.map((file, index) => {
						return (
							<ListItem
								key={index}
								secondaryAction={
                           <>
                              <IconButton
                                 edge="end"
                                 aria-label="delete"
                                 onClick={() => handleDownloadFile(file)}
                                 sx={{ mr: 2 }}
                              >
                                 <DownloadRoundedIcon />
                              </IconButton>
                              <IconButton
                                 edge="end"
                                 aria-label="delete"
                                 onClick={() => handleDeleteFile(file)}
                              >
                                 <DeleteIcon />
                              </IconButton>
                           </>
                        }
							>
								<ListItemAvatar>
									<Avatar sx={{ bgcolor: "blue.main" }}>
										<InsertDriveFileIcon
											sx={{ color: "blue.light" }}
										/>
									</Avatar>
								</ListItemAvatar>
								<ListItemText
									primary={file.filePath ? file.filePath : file.name}
									secondary={false ? "Secondary text" : null}
								/>
							</ListItem>
						);
					})}
				</List>
			</Box>
		</Box>
	);
}
